import React, { useState } from "react";
import NetaqInput from "./NetaqInput";
import { useTranslate } from "./TranslationText";
import NewActionButton from "./ActionButtons/NewActionButton";
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from "../common/cssclasses";

// Flutter API filter keys: name (title), serviceCategoryName (category), publishDateFrom (yyyy), publishDateTo (yyyy)

const initFilterState = {
  title: "",    // → API key: name
  category: "", // → API key: serviceCategoryName (empty = All)
  DateFrom: "", // → API key: publishDateFrom (year only)
  DateTo: "",   // → API key: publishDateTo (year only)
};

const LibraryFilter = ({ onSubmit, categories = [] }) => {
  const { translate } = useTranslate();
  const [dateStartFrom, setDateStartFrom] = useState(null);
  const [dateStartTo, setDateStartTo] = useState(null);
  const [filterState, setFilterState] = useState(initFilterState);

  const handleChange = (event, input) => {
    if (input === "DateFrom") {
      setDateStartFrom(event);
      setFilterState(prev => ({
        ...prev,
        DateFrom: event && event.$d ? event.$d.toISOString() : "",
      }));
      return;
    }
    if (input === "DateTo") {
      setDateStartTo(event);
      setFilterState(prev => ({
        ...prev,
        DateTo: event && event.$d ? event.$d.toISOString() : "",
      }));
      return;
    }
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setFilterState(prev => ({ ...prev, [event.target.name]: value }));
  };

  const handleSubmit = (event) => {
    window.scrollTo(0, 0);
    event.preventDefault();
    onSubmit(filterState);
  };

  const handleReset = () => {
    window.scrollTo(0, 0);
    setDateStartFrom(null);
    setDateStartTo(null);
    const cleared = { ...initFilterState };
    setFilterState(cleared);
    onSubmit(cleared); // ← IMPORTANT: trigger re-fetch with empty filters
  };

  return (
    <form className={filterCard} onSubmit={handleSubmit} onReset={handleReset}>
      <h2 className={filterHeader}>{translate('web.simplesearch', 'Search')}</h2>

      {/* Title */}
      <div className="mb-form-group">
        <NetaqInput
          name="title"
          label={translate("web.courseTitle", "Title")}
          placeholder={translate("web.courseTitle", "Title")}
          type="text"
          onChange={handleChange}
          value={filterState.title}
        />
      </div>

      {/* Category — React-Select dropdown from dynamic list */}
      <div className="mb-form-group">
        <NetaqInput
          name="category"
          label={translate("web.category", "Category")}
          placeholder={translate("web.category", "Category")}
          type="select"
          listSelect={categories}
          isClearable={true}
          value={filterState.category ? categories?.find(cat => cat.value === filterState.category) || null : null}
          onChange={(selectedItem) => {
            setFilterState(prev => ({
              ...prev,
              category: selectedItem?.value ?? "",
            }));
          }}
        />
      </div>

      {/* Year-only Date Range (Flutter uses year format) */}
      <div className="row mb-form-group-last">
        <label className="mt-2">
          {translate('web.publishingDate', 'Publishing Date')}
        </label>
        <div className="col-6">
          <NetaqInput
            name="DateFrom"
            type="date"
            justYear
            label={<>{translate("web.from", "From")}</>}
            onChange={handleChange}
            value={dateStartFrom}
          />
        </div>
        <div className="col-6">
          <NetaqInput
            name="DateTo"
            type="date"
            justYear
            label={<>{translate("web.to", "To")}</>}
            onChange={handleChange}
            value={dateStartTo}
            minDate={dateStartFrom}
          />
        </div>
      </div>

      <div className={filterButtonsContainer}>
        <div className={filterResetBtn}>
          <NewActionButton
            isButton
            classNames="btn-outline-secondary"
            type="reset"
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            type="submit"
          />
        </div>
      </div>
    </form>
  );
};

export default LibraryFilter;
